<div *ngIf="infoData" class="info-icon" matTooltip="{{ infoData.message }}" matTooltipClass="info-tooltip" matTooltipPosition="{{ matTooltipPosition }}">
	<img alt="info-icon-box" src="../../../../assets/icons/info-icon-hover.svg" />
</div>
